import { CommandAction } from "@/contexts/command-palette-context"
import type { SearchResult } from "@/schema/search"

interface CommandFooterProps {
  selectedItem?: SearchResult | CommandAction
  isAction?: boolean
}

export function CommandFooter({ selectedItem, isAction }: CommandFooterProps) {
  if (!selectedItem) return null

  const getTypeLabel = (type: string) => {
    const typeLabels: Record<string, string> = {
      person: "person",
      household: "household",
      client: "client",
      past_client: "past client",
      prospect: "prospect",
      contact: "contact",
      opportunity: "opportunity",
      sms_message: "message",
    }
    return typeLabels[type] || type
  }

  const footerText = isAction
    ? (selectedItem as CommandAction).footerText || `Execute ${(selectedItem as CommandAction).label}`
    : `Go to ${getTypeLabel((selectedItem as SearchResult).type)}`

  return (
    <div className="text-muted-foreground flex items-center justify-end border-t px-3 py-2 text-xs">
      <div className="flex items-center gap-2">
        <span>{footerText}</span>
        <kbd className="bg-muted text-muted-foreground pointer-events-none inline-flex h-5 items-center gap-1 rounded border px-1.5 font-mono text-[10px] font-medium opacity-100 select-none">
          <span className="text-xs">↵</span>
        </kbd>
      </div>
    </div>
  )
}
